import { NgModule } from '@angular/core';
import { CfAlertsService } from './alerts.service';
export class CfAlertsServiceModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [],
  declarations: [],
  entryComponents: [],
  providers: [
    CfAlertsService
  ],
  exports: [],
  schemas: []
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function CfAlertsServiceModule_tsickle_Closure_declarations() {
/** @type {?} */
CfAlertsServiceModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CfAlertsServiceModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
